import { Spinner as DsSpinner } from 'ui/components/Spinner';

export const LocalSpinner = () => (
	<div className="relative flex h-screen items-center justify-center">
		<DsSpinner size="lg" />
	</div>
);
